var cohortApi = {};
export {
  cohortApi as __exports
};
//# sourceMappingURL=cohort-api.js.map
